import myoshLogo from './myosh-logo.svg';
import myoshLogoWhite from './myosh-logo-white-text.svg';

export const Logo = { myoshLogo, myoshLogoWhite };
